import React from 'react'
import { Link } from 'react-router-dom';
import {database} from '../firebase';
import { collection,getDocs} from 'firebase/firestore';

class Sidebar extends React.Component{
constructor(){
  super()
  this.state = {
    dataPost:[],
    category:['Anime','Manga','Games','Sports','Technology','Other'],
    month:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
    hide:false,
    recomend:[]
  }
}


async componentDidMount(){

  const db = collection(database,'post')

                //  GET ALL POIST

await getDocs(db).then(res => {
if (res) {
  res.docs.map(item => {
    const data = item.data()
    if(data.total_likes > 4){
      this.setState({ 
        hide:this.state.hide = true
       })  
    }
  })
  return this.setState({ 
    dataPost:this.state.dataPost = res
   })  

  }
})


}


    render(){

      const titlePost = Array.isArray(this.state.dataPost.docs) ? this.state.dataPost.docs.map((post,index)=> {
        const posts = post.data()
        return  <li key={index} ><Link to={`/post-detail/${posts.post_id}`}>{posts.title}</Link></li>
        }) : ""
     
      const Recomendation  = Array.isArray(this.state.dataPost.docs) ? this.state.dataPost.docs.map((post,index)=> {
        const posts = post.data()
            return  posts.total_likes > 4 ?  <li key={index} ><Link to={`/post-detail/${posts.post_id}`}>{posts.title}</Link></li> : console.log("asd");    
        }) : ""

      return(
        <aside className='post-right'>
         <div className='right-menu'>
         <div className='new-post'>
         <div className='judul-post'>
           <h3> Newest Post</h3>
         </div>
         <ul className='list'>
           {titlePost}
         </ul>
        </div>
        <div className={this.state.hide ? 'new-post' : 'hide'}>
        <div className='judul-post'>
           <h3>Post Recomendation</h3>
        </div>
         <ul className='list'>
          {Recomendation}
         </ul>
        </div>
        <div className='new-post'>
         <div className='judul-post'>
           <h3>Post Category</h3>
         </div>
         <ul className='list'>
         {this.state.category.map(cat => {
           return <li key={cat}><Link to={`/category/${cat}`} >{cat}</Link></li>
         })
        }
         </ul>
        </div>
         </div>
     </aside>
    )
    }
}

export default Sidebar;